export default __webpack_public_path__ + "static/media/right-arrow.53cdda50.svg";